import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
Vue.use(Router)

const router = new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/home',
      redirect: 'menu',
      component: DashboardLayout,
      children: [
        {
          path: '/menu',
          name: 'Accueil',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Home.vue')
        },
        {
          path: '/addProduct/:id',
          name: 'addproduct',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Produit/AddProduct.vue')
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Dashboard.vue')
        },
        {
          path: '/caisse/:id',
          name: 'caisse',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Tables/DeliveryTable.vue')
        },
        {
          path: '/sp',
          name: 'sp',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/SPTables.vue')
        },
        {
          path: '/historique',
          name: 'historique',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Historique.vue')
        },
        {
          path: '/retours',
          name: 'retours',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Returns.vue')
        },
        {
          path: '/payments',
          name: 'payments',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Payments.vue')
        },
        {
          path: '/categorie',
          name: 'liste des categories',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/ListeCategorie.vue')
        },
        {
          path: '/listeproduit/:id?',
          name: 'products',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/ListeProduit.vue')
        },
        {
          path: '/permissions/:id',
          name: 'permissions',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Permissions.vue')
        },
        {
          path: '/maps',
          name: 'maps',
          /// component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Maps.vue')
        },
        {
          path: '/tablesuser',
          name: 'liste des utilisateurs',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/TablesUser.vue')
        },
        {
          path: '/appsettings',
          name: 'Paramètre du plateforme',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Settings.vue')
        },
        {
          path: '/caissehistory',
          name: 'Historiquedecaisse',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/TablesCaisse.vue')
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Profile.vue')
        },
        {
          path: '/tablesclient',
          name: 'clients',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/TablesClient.vue')
        }
      ]
    },
    {
      path: '/login',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Login.vue')
        },
        {
          path: '/register',
          name: 'register',
          // component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/Register.vue')
        }
      ]
    },
    {
      path: '/myspace/:id',
      name: 'myspace',
      component: () => import(/* webpackChunkName: "hometrocaccess" */ './views/MySpace.vue')
    },
    {
      path: "*",
      redirect: 'dashboard',
      component: DashboardLayout
    }
  ]
})

router.beforeEach((to, from, next) => {
  let isAuthenticated = localStorage.getItem("accessToken") ? true : false;
  // if (!isAuthenticated && to.path != "/login" && to.path != "/") next("/login");
  // if (isAuthenticated && to.path == "/login") next("/");
  if (to.name !== 'login' && !isAuthenticated && to.name !== "myspace") next({ name: 'login' })
  // const amIVisible = (text) => {
  //   const permissions = (localStorage.getItem("permissions") || "").split(
  //     ";"
  //   );
  //   return permissions.some((x) => x == text);
  // }
  // const mappings = [{ name: 'dashboard', text: 'Dashboard' }, { name: 'products', text: 'Articles' }, { name: 'caisse', text: 'Caisse' }, { name: 'Historiquedecaisse', text: 'Historique caisse' }, { name: 'retours', text: 'Retours' }, { name: 'payments', text: 'Paiements' }, { name: 'historique', text: 'Historique' }]
  // const text = (mappings.find(x => x.name == to.name) || {}).text
  if (to.name == 'login' && isAuthenticated) next({ name: 'Accueil' });
  // if ((!amIVisible(text) && text)) next({ name: 'Accueil' })
  else next();
});
export default router;
